import { render } from "./ViewPhotoV2.vue?vue&type=template&id=59537a20&scoped=true"
import script from "./ViewPhotoV2.vue?vue&type=script&lang=js"
export * from "./ViewPhotoV2.vue?vue&type=script&lang=js"

import "./ViewPhotoV2.vue?vue&type=style&index=0&id=59537a20&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59537a20"]])

export default __exports__